// removed by extract-text-webpack-plugin
module.exports = {"Table":"src-components-Promo-__PromosTable-module___Table"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Promo/PromosTable.module.css
// module id = 454
// module chunks = 1